import { UnidadeGestoraResumida } from "../ug/unidade-gestora-resumida";
import { UsuarioSumario } from "../usuario-sumario";

export class FiltrosAvisos {
  titulo: string;
  mensagem: string;
  usuarioCriador?: UsuarioSumario;
  usuarioDestinatario?: UsuarioSumario;
  ug?: UnidadeGestoraResumida;
  tipoUg: any;
  tipoAviso: number | null = 1
  dataInicio: Date;
  dataFim: Date;

  constructor() {
    this.limpar();
  }

  limpar(): void {
    this.titulo = "";
    this.mensagem = "";
    this.usuarioCriador = undefined;
    this.usuarioDestinatario = undefined;
    this.ug = undefined;
    this.tipoUg = null;
    this.tipoAviso = 1;
    this.dataInicio = new Date();
    this.dataInicio.setMonth(0);
    this.dataInicio.setDate(1);
    this.dataFim = new Date();
  }

  estaVazio(): boolean {
    return (
      !this.titulo &&
      !this.mensagem &&
      !this.usuarioCriador &&
      !this.usuarioDestinatario &&
      !this.ug &&
      !this.tipoUg &&
      !this.tipoAviso &&
      !this.dataInicio &&
      !this.dataFim
    );
  }

  toFormData(): FormData {
    const data = new FormData();
    if (this.titulo) data.append("titulo", this.titulo);
    if (this.mensagem) data.append("filtroMsg", this.mensagem);
    if (this.usuarioCriador) data.append("usuario", this.usuarioCriador.Nome);
    if (this.usuarioDestinatario)
      data.append("idUsuario", this.usuarioDestinatario.IdUsuario.toString());
    if (this.ug) data.append("ug", String(this.ug.IdPCM));
    if (this.tipoUg) data.append("tipoUg", this.tipoUg);
    if (this.tipoAviso) data.append("tipoAviso", String(this.tipoAviso));
    if (this.dataInicio)
      data.append("dataCadastroInicio", this.dataInicio.toISOString());
    if (this.dataFim)
      data.append("dataCadastroFim", this.dataFim.toISOString());
    return data;
  }
}
